import axios from 'axios'

const apiAdmin = axios.create({
  baseURL: 'https://mns.gelogs.co.th/api/admin/',
  headers: {
    'Content-Type': 'application/json',
  },
})

apiAdmin.interceptors.request.use(
  config => {
    const token = localStorage.getItem('accessToken')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => Promise.reject(error),
)

export default apiAdmin
